/** Emblemele mărcilor fictive, desenate după descrierile din `data/brands.json`. */

const chrome = (id: string) =>
  `<linearGradient id="${id}" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#f4f6f8"/><stop offset=".45" stop-color="#9aa3ad"/><stop offset=".55" stop-color="#d9dee3"/><stop offset="1" stop-color="#6f7882"/></linearGradient>`;

function wendland(): string {
  const blade = (rot: number) => `<path d="M0 -4 C 10 -10, 22 -14, 30 -6 C 22 -8, 12 -4, 4 4 Z" fill="#fff" transform="rotate(${rot})"/>`;
  return `<svg viewBox="-50 -50 100 100" aria-hidden="true"><defs>${chrome('wc')}</defs>
    <circle r="48" fill="url(#wc)"/><circle r="43" fill="#1d3b6e"/>
    <g>${blade(0)}${blade(120)}${blade(240)}</g><circle r="5" fill="#fff"/><circle r="2.2" fill="#1d3b6e"/></svg>`;
}

function rheinhardt(): string {
  return `<svg viewBox="0 0 100 100" aria-hidden="true"><defs>${chrome('rc')}</defs>
    <path d="M50 4 L88 14 L84 58 C80 78 66 90 50 97 C34 90 20 78 16 58 L12 14 Z" fill="#16181c"/>
    <path d="M50 9 L83 18 L79 57 C76 74 64 85 50 91 C36 85 24 74 21 57 L17 18 Z" fill="url(#rc)"/>
    <text x="50" y="58" text-anchor="middle" font-family="Georgia, 'Times New Roman', serif" font-size="40" font-weight="700" fill="#16181c">R</text>
    <g fill="none" stroke="#2f6db5" stroke-width="3.2" stroke-linecap="round">
      <path d="M28 68 q5.5 -5 11 0 t11 0 t11 0 t11 0"/><path d="M31 75 q5 -4.5 10 0 t10 0 t10 0 t8 0"/><path d="M36 82 q4.5 -4 9 0 t9 0 t9 0"/></g></svg>`;
}

function kazemoto(): string {
  const arm = (rot: number) => `<path d="M0 0 C 8 -6, 22 -6, 30 6" fill="none" stroke="#c8102e" stroke-width="7" stroke-linecap="round" transform="rotate(${rot})"/>`;
  return `<svg viewBox="-50 -50 100 100" aria-hidden="true"><defs>${chrome('kc')}</defs>
    <circle r="47" fill="none" stroke="url(#kc)" stroke-width="7"/><circle r="40" fill="#f6f7f8"/>
    ${arm(0)}${arm(120)}${arm(240)}<circle r="4.5" fill="#c8102e"/></svg>`;
}

function stallard(): string {
  const feathers = [0, 1, 2, 3, 4].map((i) => `<path d="M${50 - i * 9} ${34 + i * 2.6} L${6 + i * 3} ${30 + i * 5.4} L${12 + i * 3} ${36 + i * 5.4} L${50 - i * 9} ${40 + i * 2.6} Z" fill="url(#sc)" stroke="#5c646e" stroke-width=".6"/>`).join('');
  const mirror = feathers.replace(/M(\d+(?:\.\d+)?) /g, (_, x) => `M${100 - Number(x)} `).replace(/L(\d+(?:\.\d+)?) /g, (_, x) => `L${100 - Number(x)} `);
  return `<svg viewBox="0 0 100 100" aria-hidden="true"><defs>${chrome('sc')}</defs>
    <rect x="20" y="58" width="60" height="5" fill="#b22234"/><rect x="20" y="63" width="60" height="4" fill="#ffffff"/><rect x="20" y="67" width="60" height="5" fill="#3c3b6e"/>
    ${feathers}${mirror}<circle cx="50" cy="44" r="7" fill="url(#sc)" stroke="#5c646e"/>
    <text x="50" y="88" text-anchor="middle" font-family="Rockwell, 'Roboto Slab', Georgia, serif" font-size="13" font-weight="800" letter-spacing="1.5" fill="url(#sc)" stroke="#2a2f35" stroke-width=".5">STALLARD</text></svg>`;
}

function zarya(): string {
  const rays = [-60, -30, 0, 30, 60].map((a) => `<line x1="50" y1="54" x2="${50 + Math.sin((a * Math.PI) / 180) * 30}" y2="${54 - Math.cos((a * Math.PI) / 180) * 30}" stroke="#f2b705" stroke-width="3.5" stroke-linecap="round"/>`).join('');
  return `<svg viewBox="0 0 100 100" aria-hidden="true">
    <path d="M50 4 L95 37 L78 92 L22 92 L5 37 Z" fill="#c1121f" stroke="#7d0b14" stroke-width="2"/>
    ${rays}<path d="M34 54 A16 16 0 0 1 66 54 Z" fill="#f2b705"/><line x1="22" y1="55" x2="78" y2="55" stroke="#f2b705" stroke-width="3"/>
    <text x="50" y="80" text-anchor="middle" font-family="'Arial Narrow', Arial, sans-serif" font-size="15" font-weight="700" letter-spacing="1" fill="#f2b705">ЗАРЯ</text></svg>`;
}

const LOGOS: Record<string, () => string> = { wendland, rheinhardt, kazemoto, stallard, zarya };

export function brandLogo(id: string): string {
  return (LOGOS[id] ?? wendland)();
}
